var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15917 0.833252H12.8418C15.6733 0.833252 17.25 2.46492 17.25 5.26075V14.7299C17.25 17.5716 15.6733 19.1666 12.8418 19.1666H5.15917C2.3725 19.1666 0.75 17.5716 0.75 14.7299V5.26075C0.75 2.46492 2.3725 0.833252 5.15917 0.833252ZM5.40667 5.10492V5.09575H8.14658C8.54167 5.09575 8.8625 5.41658 8.8625 5.80984C8.8625 6.21409 8.54167 6.53492 8.14658 6.53492H5.40667C5.01158 6.53492 4.69167 6.21409 4.69167 5.81992C4.69167 5.42575 5.01158 5.10492 5.40667 5.10492ZM5.40667 10.6783H12.5933C12.9875 10.6783 13.3083 10.3574 13.3083 9.96325C13.3083 9.56909 12.9875 9.24734 12.5933 9.24734H5.40667C5.01158 9.24734 4.69167 9.56909 4.69167 9.96325C4.69167 10.3574 5.01158 10.6783 5.40667 10.6783ZM5.40667 14.8674H12.5933C12.9591 14.8308 13.235 14.5182 13.235 14.1524C13.235 13.7766 12.9591 13.4649 12.5933 13.4283H5.40667C5.13167 13.4008 4.86583 13.5291 4.71917 13.7674C4.5725 13.9966 4.5725 14.2991 4.71917 14.5374C4.86583 14.7666 5.13167 14.9041 5.40667 14.8674Z",
    fill: "#605BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBlue);
export default __webpack_public_path__ + "static/media/document-blue.c992b3d63b3ed9a6dd4a145ad4e8c68c.svg";
export { ForwardRef as ReactComponent };